import axios from "axios";
import Cookies from "js-cookie";

var HOST = process.env.VUE_APP_LOCAL_BACKEND;

if (process.env.APP_ENV === "prod") {
  HOST = process.env.BACKEND;
}

export function getCookie(cname) {
  return Cookies.get(cname);
}

// SetCookies saves the session token
// cname: token name
// cvalue: token value
// exdays: the number of days until the token expires
export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  var multyplayer = 1 * 60 * 60 * 1000; // to hour
  d.setTime(d.getTime() + exdays * multyplayer); // from miliseconds to days;
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  (config) => {
    config.headers.authorization = `Bearer ${Cookies.get("jwt")}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function setWithExpiry(key, value, ttl) {
  const now = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl * 60 * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

// User

export const registerUser = async (user) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/users`, {
      username: user.username,
      password: user.password,
      UserRoles: user.roles,
      email: user.email,
      enabled: user.enabled,
      organizationName: user.organizationName,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editUser = async (id, user) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/users/${id}`, {
      id: user.id,
      username: user.username,
      password: user.password,
      UserRoles: user.roles,
      email: user.email,
      enabled: user.enabled,
      organizationName: user.organizationName,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const userLogin = async (User) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/users/login`, {
      username: User.usrn,
      password: User.pwd,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/users/getMe`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const GetAllUsers = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/users`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const GetUser = async (userID) => {
  try {
    const response = await axios.get(`${HOST}/api/v1/users/${userID}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const disableUser = async (userID) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/users/disable/${userID}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const deleteUser = async (userID) => {
  try {
    const response = await axios.delete(`${HOST}/api/v1/users/${userID}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const enableUser = async (userID) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/users/enable/${userID}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

// forms

export const createForm = async (form) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/forms`, {
      liftingDate: form.liftingDate,
      fillingResponsable: form.fillingResponsable,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteForm = async (code) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/forms/${code}`, {
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateForm = async (form) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/forms/${form.code}`, {
      id: form.id,
      date: form.date,
      status: form.status,
      domain: form.domain,
      name: form.name,
      goal: form.goal,
      observationUnit: form.observationUnit,
      userID: form.userID,
      responsableID: form.responsableID,
      courtID: form.courtID,
      court: form.court,
      organizationID: form.organizationID,
      evidence: form.evidence,
      answers: form.answers,
      evidences: form.evidences,
      code: form.code,
      user: form.user,
      liftingDate: form.liftingDate,
      fillingResponsable: form.fillingResponsable,
      responsable: form.responsable,
      organization: form.organization,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addAnswers = async (formID, answers) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/answers`, {
      formID: formID,
      answers: answers,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getFormCount = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms/count`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getEveryForm = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms/all`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const approveForm = async (formID) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/forms/approve/${formID}`,
      {}
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const rejectForm = async (formID) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/forms/reject/${formID}`,
      {}
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const publishForm = async (formID) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/forms/publish/${formID}`,
      {}
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getQuestions = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/questions`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const GetAllForms = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const getForm = async (formID) => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms/${formID}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const getFormByCode = async (formCode) => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms/code/${formCode}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const getPublicForm = async (formID) => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms/public/${formID}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const getAllPublicForm = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/forms/publics`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};


// Organizations

export const GetAllOrganizations = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/organizations`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const GetAllOrganizationsActive = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/organizations/active`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const registerOrg = async (org) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/organizations`, {
      name: org.name,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editOrg = async (id, org) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/organizations/${id}`, {
      id: org.id,
      name: org.name,
      enabled: org.enabled,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const disableOrg = async (orgID) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/organizations/disable/${orgID}`
    );
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const enableOrg = async (orgID) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/organizations/enable/${orgID}`
    );
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

// permissions

export const GetAllPermissions = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/permissions`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const GetAllRoles = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/roles`);
    return response;
  } catch (error) {
    if (!error.response) {
      return "Server down";
    }
    return error.response;
  }
};

export const registerPermission = async (per) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/permissions`, {
      name: per.name,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const registerRol = async (rol) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/roles`, {
      name: rol.name,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addPermissions = async (permission) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/roles/assign`, {
      roleID: permission.roleID,
      permissions: permission.permissions,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editRole = async (id, per) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/roles/${id}`, {
      id: per.id,
      name: per.name,
      permissions: per.permissions,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addRole = async (id, rol) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/users/role`, {
      roleID: rol,
      userID: id,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const removeRole = async (usrrolID, usrID, rol) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/users/role/remove`, {
      userID: usrID,
      id: usrrolID,
      roleID: rol,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

//Auxiliares

export const getAllAuxiliar = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/auxiliar`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addAuxiliar = async (aux) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/auxiliar`, {
      name: aux.name,
      type: aux.type,
      value: aux.value,
      dependency: aux.dependency,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editAuxiliar = async (id, auxiliar) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/auxiliar/${id}`, {
      id: id,
      name: auxiliar.name,
      value: auxiliar.value,
      type: auxiliar.type,
      dependency: auxiliar.dependency,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const removeAuxiliar = async (id) => {
  try {
    const response = await axios.delete(`${HOST}/api/v1/auxiliar/${id}`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAuxiliarByType = async (type) => {
  try {
    const response = await axios.get(
      `${HOST}/api/v1/auxiliar/type/${type}`,
      {}
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAuxiliarByTypeWithDependency = async (type, dependency) => {
  try {
    const response = await axios.get(
      `${HOST}/api/v1/auxiliar/type/${type}/${dependency}`,
      {}
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

// permissions

export const getAllPermissions = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/permissions`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAllroles = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/roles`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addRol = async (name) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/roles`, {
      name: name,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const togglePermission = async (role, permission) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/roles/togglePermission`, {
      rolName: role,
      permission: permission,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editPermission = async (id, permission) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/permissions/${id}`, {
      id: permission.id,
      name: permission.name,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addPermission = async (permission) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/permissions/`, {
      name: permission,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const removePermission = async (id) => {
  try {
    const response = await axios.delete(`${HOST}/api/v1/permissions/${id}`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

// courts

export const getFormsInCourt = async (id) => {
  try {
    const response = await axios.get(`${HOST}/api/v1/courts/${id}`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const downloadCourt = async (id) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/courts/download/${id}`,
      {},
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getCourts = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/courts`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const generateCourt = async (data) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/courts`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

// evidences

export const addEvidence = async (data) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/evidence`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getEvidenceFile = async (id) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/evidence/${id}/download`,
      {},
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const removeEvidence = async (id) => {
  try {
    const response = await axios.delete(`${HOST}/api/v1/evidence/${id}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

// counters

export const getcounters = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/counters`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getcountersPublics = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/counters/publics`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};


// Guides

export const addGuide = async (data) => {
  try {
    const response = await axios.post(`${HOST}/api/v1/guides`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateGuide = async (id, data) => {
  try {
    const response = await axios.put(`${HOST}/api/v1/guides/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getGuides = async () => {
  try {
    const response = await axios.get(`${HOST}/api/v1/guides`, {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getGuideFile = async (id) => {
  try {
    const response = await axios.post(
      `${HOST}/api/v1/guides/${id}/download`,
      {},
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const removeGuide = async (id) => {
  try {
    const response = await axios.delete(`${HOST}/api/v1/guides/${id}`);
    return response;
  } catch (error) {
    return error.response;
  }
};